export default __webpack_public_path__ + "static/media/SalePrices.51cc150c.svg";